<template>
    <app-layout>


        <div class="-mt-6 flex flex-grow flex-col">

            <div class="flex flex-col mx-auto justify-center flex-grow">

                <!-- <img src="/img/nyan-cat.gif" alt="nyancat" width="160" class="mx-auto" /> -->
                <div class="w-96 rounded-lg bg-gray-400 h-56 flex justify-center items-center shadow-md">
                    <NoSymbolIcon class="w-12 h-12 text-gray-500" />
                </div>

                <h4 class="text-center font-bold text-xl mt-8 text-gray-800">This video has been deleted</h4>


                <div class="text-center font-light text-lg mt-3 text-gray-500">
                    <!-- <p>Double-check the URL… or ask Uncle Charlie for a new link.<br />
                        Either way, may the force be with you!</p>
                        <p>&nbsp;</p> -->
                    <p v-if="$page.props.user">
                        <a :href="route('library.incoming')" title="Back to your library"
                            class="text-blue-500 hover:underline flex justify-center items-center gap-x-2">
                            <ArrowLeftIcon class="w-4 h-4" /> Back to your library
                        </a>
                    </p>
                    <p v-else>
                        <a href="https://www.birdie.so" title="Back to Birdie homepage"
                            class="text-blue-500 hover:underline flex justify-center items-center gap-x-2">
                            <ArrowLeftIcon class="w-4 h-4" /> Go to Birdie homepage
                        </a>
                    </p>
                </div>



            </div>


            <div class="relative w-full bg-blue-500 text-white text-center py-6" v-if="footer_view">
                <a href="#" @click.prevent.stop="footer_view = false"
                    class="absolute top-3 right-4 h-4 w-4 hover:text-blue-800" title="Close">
                    <vue-feather type="x" class="h-4 w-4"></vue-feather>
                </a>

                <h5 class="text-2xl font-semibold">Secure screen recording for modern Support teams and their customers.
                </h5>
                <p class="text-lg font-medium">Speed up resolution and provide an outstanding experience.</p>
                <p class="mt-3">
                    <a :href="'https://www.' + domain" taget="_blank" :title="'Add ' + app_name + ' to your helpdesk'"
                        class="mt-3 inline-flex items-center px-4 py-2 bg-white border-2 border-transparent rounded-md font-bold text-sm text-blue-500 uppercase tracking-widest hover:bg-blue-500 hover:text-white hover:border-white active:bg-blue-500 focus:outline-none focus:border-white focus:ring focus:ring-white disabled:opacity-25 transition">
                        Add {{ app_name }} to your helpdesk
                    </a>
                </p>
            </div>


        </div>

    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import { ArrowLeftIcon } from "@heroicons/vue/24/outline";
import { NoSymbolIcon } from "@heroicons/vue/24/solid";



export default {
    props: [],

    components: {
        AppLayout, ArrowLeftIcon, NoSymbolIcon
    },
    data() {
        return {
            footer_view: false, //this.$page.props.user == null,
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            app_name: this.$page.props.app_name
        }
    },
    created() {
        // this.EventBus.on("start.call", function(toto) {
        //     this.test(toto)
        // }.bind(this));
        ///console.log(this.$page.props.user )
    },
    beforeUnmount() {
        // this.EventBus.off("start.call", this.test);
    },
    mounted() {
        // this.EventBus.emit("start.call", "hello")
    },
    methods: {
        // test(toto) {
        //     console.log("test ok", toto)
        // }
    }
}
</script>
